import {Mod, fromModule} from 'util/styler/Styler'
import React, {Fragment} from 'react'

import {Icon} from 'assets/icon'
import {Link} from 'util/link'
import css from './breadcrumbs.module.scss'
import {useLinks} from 'util/links'

const styles = fromModule(css)

export type ParentType = {
	title?: string
	url?: string
}

export const Breadcrumbs: React.FC<{
	parents: Array<ParentType>
	pageTitle: string
	pageurl?: string
	mod?: Mod<'small'>
}> = (data) => {
	const {parents, pageTitle, pageurl, mod} = data
	const {home} = useLinks()

	if (!pageTitle) return null

	const reversedParents = parents ? [...parents] : []
	reversedParents.reverse()

	return (
		<div className={styles.breadcrumbs.mod(mod)()}>
			<Link href={home.url} className={styles.breadcrumbs.icon()}>
				<Icon icon="Home" />
			</Link>
			{reversedParents.map((parent, i) => (
				<Fragment key={i}>
					<span className={styles.breadcrumbs.divider()}>/</span>
					<Link href={parent.url} className={styles.breadcrumbs.link()}>
						{parent.title}
					</Link>
				</Fragment>
			))}
			<span className={styles.breadcrumbs.divider()}>/</span>
			{!pageurl && (
				<span className={styles.breadcrumbs.link()}>{pageTitle}</span>
			)}
			{pageurl && (
				<Link href={pageurl} className={styles.breadcrumbs.link()}>
					{pageTitle}
				</Link>
			)}
		</div>
	)
}
